/** CSS-ассеты whitelabel-layout (добавлять по мере появления в QuizLayout). */
export const WHITELABEL_THEME_ASSET_CSS_PROPERTIES = {} as const;
